// Full-document render of the sealy HomePage: PageSkeleton (the React
// document shell) wrapping the existing home-page body assembly.
import React from "react";

import { templates } from "@reactivated";

import { HomePageBody } from "../components/HomePageBody";
import { PageSkeleton } from "../components/PageSkeleton";

// Mutable reactivated props (not Immutable<>): this template composes the
// in-tree SiteHeader/RichNavigation chain via PageSkeleton, which is typed
// with mutable reactivated props (see PageSkeleton). The body template accepts
// Immutable props, to which these are assignable.
export const Template = (
    props: templates.HomePageTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <HomePageBody page={props.page} />
    </PageSkeleton>
);
